import { addLead } from "../services/api.js";

document.addEventListener("DOMContentLoaded", () => {
    const contactForm = document.getElementById("contactForm");
    if (!contactForm) return;

    const contactName = document.getElementById("contactName");
    const contactEmail = document.getElementById("contactEmail");
    const contactPhone = document.getElementById("contactPhone");
    const contactRemarks = document.getElementById("contactRemarks");

    contactForm.addEventListener("submit", async (event) => {
        event.preventDefault();

        if (!validateForm()) return;

        const submitButton = contactForm.querySelector("[type='submit']");
        submitButton.classList.add("loading");

        const payload = {
            name: contactName.value.trim(),
            email: contactEmail.value.trim(),
            phone_number: contactPhone.value.trim(),
            leads_remarks: contactRemarks.value.trim(),
        };

        try {
            const res = await addLead(payload); // await API call
            console.log("API Response:", res);

            if (res) {
                Swal.fire({
                    text: "Form submitted successfully!",
                    icon: "success",
                    showConfirmButton: false,
                    timer: 3000,
                });
                contactForm.reset();
            } else {
                throw new Error("Invalid response");
            }
        } catch (error) {
            console.error("API Error:", error);
            Swal.fire({
                title: "Oops...",
                text: `${error?.response?.data?.issues?.message}` || "Something went wrong!",
                icon: "error",
                showConfirmButton: true,
            });
        } finally {
            submitButton.classList.remove("loading");
        }
    });

    // 🔁 Real-time validation
    contactForm.addEventListener("input", (event) => {
        const target = event.target;
        if (target.tagName.toLowerCase() === "input") {
            validateField(target);
        }
    });

    // =========================
    // ✅ Validation Functions
    // =========================
    function validateForm() {
        let isValid = true;
        [contactName, contactEmail, contactPhone, contactRemarks].forEach((field) => {
            isValid = validateField(field) && isValid;
        });
        return isValid;
    }

    function validateField(field) {
        const fieldName = field.name;
        const fieldValue = field.value.trim();
        const errorSpan = document.getElementById(`${fieldName}Error`);
        const formControl = field.parentElement;

        errorSpan.textContent = "";
        formControl.classList.remove("error");

        if (!fieldValue) {
            errorSpan.textContent = `${capitalize(fieldName)} is required`;
            formControl.classList.add("error");
            return false;
        }

        if (fieldName === "name" && !isValidName(fieldValue)) {
            errorSpan.textContent = "Invalid name";
            formControl.classList.add("error");
            return false;
        }

        if (fieldName === "email" && !isValidEmail(fieldValue)) {
            errorSpan.textContent = "Invalid email address";
            formControl.classList.add("error");
            return false;
        }

        if (fieldName === "phone" && !isValidMobile(fieldValue)) {
            errorSpan.textContent = "Invalid mobile number";
            formControl.classList.add("error");
            return false;
        }

        return true;
    }

    function isValidName(name) {
        return /^[a-zA-Z\s]{3,}$/.test(name);
    }

    function isValidEmail(email) {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    }

    function isValidMobile(mobile) {
        return /^(\+91[\-\s]?)?[0]?(91)?[6789]\d{9}$/.test(mobile);
    }

    function capitalize(str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    }
});
